const React = require('react');
const ArrowBackIcon = require('@material-ui/icons/ArrowBack').default;
const AddCircleOutlineIcon
  = require('@material-ui/icons/AddCircleOutline').default;
const DeleteIcon = require('@material-ui/icons/Delete').default;
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const map = require('mn-utils/map');
const trim = require('mn-utils/trim');
const isArray = require('mn-utils/isArray');
const withState = require('../../../../utils/withState');
const {
  backLocation,
} = require('../../../../router');
const {
  apiAdminMposUsersList,
  apiAdminMposUsersCreate,
  apiAdminMposUsersUpdate,
  apiAdminMposUsersDelete,
} = require('../../../../api/admin/mposUsers');
const {
  confirmRemove,
} = require('../../../../emitters/remove');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonD = require('../../../dumb/Button/D');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const ColA = require('../../../dumb/Col/A');
const TextField = require('../../../dumb/TextField/Reg2');
const ButtonF = require('../../../dumb/Button/F');


module.exports = withState((setState, self, onMount) => {
  let _cancel = noop;
  let _merchantId;

  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });
      _cancel = apiAdminMposUsersList({
        merchant_id: _merchantId,
      }).finally((error, response) => {
        setState({
          loading: false,
          items: isArray(response)
            ? response
            : response && response.list || [],
        });
      }).cancel;
    });
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });
  return (state, props) => {
    const params = props.params || {};
    const merchantId = params.id;
    _merchantId === merchantId || update(_merchantId = merchantId);

    const items = state.items || [];
    const {
      loading,
    } = state;

    const newBranchName = state.newBranchName || '';
    const _newBranchName = trim(newBranchName);

    return (
      <LayoutA>
        <HeaderA>
          <CaptionA
            className="fx1 wmin0"
            description={merchantId}
          >MPos credentials</CaptionA>
          <ButtonD
            onClick={backLocation}
          >
            <ArrowBackIcon/>
            <div className="pl15">Back</div>
          </ButtonD>
        </HeaderA>
        <div className="layoutRow fhaS fvaC mt30">
          <div className="pr10 fx1">
            <TextField
              label="new branch name"
              value={newBranchName}
              onChange={(e) => {
                setState({
                  newBranchName: e.target.value,
                });
              }}
              maxLength={250}
            />
          </div>
          <ButtonF
            className="wmin110"
            onClick={() => {
              setState({
                loading: true,
              });
              apiAdminMposUsersCreate({
                merchant_id: merchantId,
                name: _newBranchName,
              }).finally((error, response) => {
                error
                  ? setState({
                    loading: false,
                  })
                  : setState({
                    loading: false,
                    newBranchName: '',
                    items: [
                      response,
                      ...items,
                    ],
                  });
              });
            }}
          >
            <AddCircleOutlineIcon/>
            <div className="pl10">Add</div>
          </ButtonF>
        </div>
        <div className="abs st170 sh-45 sb10 ov">
          <div className="ovxA abs s ph45">
            <div className="wmin400 rlv h">
              <div className="abs st sh-45 sb ovxH ovyA bc4B4D51 bs b bt1">
                <WrapperWithLoading
                  className="sq"
                  inner={{
                    className: 'sq',
                  }}
                  loading={loading}
                >
                  {map(items, (item, i) => {
                    const {
                      id,
                      name,
                    } = item;
                    let _name = item._name;
                    _name === undefined && (_name = name);

                    function setItem(_item, _state) {
                      const _items = [...items];
                      _items[i] = {
                        ...item,
                        ..._item,
                      };
                      setState({
                        ...(_state || {}),
                        items: _items,
                      });
                    }

                    return (
                      <RowA
                        key={id || i}
                        className="f15 rlv"
                      >
                        <ColA className="w(|min)300">
                          <Tooltip>{item.code}</Tooltip>
                        </ColA>
                        <ColA className="wmin200 fx1 layoutRow fhaS fvaC">
                          <TextField
                            className="fx1"
                            label="Name"
                            value={_name}
                            maxLength={250}
                            onChange={(e) => {
                              setItem({
                                _name: e.target.value,
                              });
                            }}
                          />
                          <ButtonF
                            className="ml10"
                            disabled={_name === name}
                            onClick={() => {
                              setState({
                                loading: true,
                              });
                              apiAdminMposUsersUpdate({
                                branch_id: id,
                                name: _name,
                              }).finally((error) => {
                                setItem({
                                  name: error ? name : _name,
                                }, {
                                  loading: false,
                                });
                              });
                            }}
                          >Save</ButtonF>
                          <ButtonF
                            className="ml10"
                            onClick={() => {
                              confirmRemove(() => {
                                setState({
                                  loading: true,
                                });
                                apiAdminMposUsersDelete({
                                  branch_id: id,
                                }).finally((error) => {
                                  if (error) {
                                    setState({
                                      loading: false,
                                    });
                                    return;
                                  }
                                  const _items = [...items];
                                  _items.splice(i, 1);
                                  setState({
                                    loading: false,
                                    items: _items,
                                  });
                                });
                              });
                            }}
                          >
                            <DeleteIcon/>
                          </ButtonF>
                        </ColA>
                      </RowA>
                    );
                  }, [])}
                </WrapperWithLoading>
              </div>
            </div>
          </div>
        </div>
      </LayoutA>
    );
  };
});
